import { DgtPdOrderOperationLog } from "../models"
import { memo } from 'react'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { AiOutlineClose } from 'react-icons/ai'
import { SummaryLogRow } from "../constants/Column"

const CancelConfirmEditor = memo(({ props } : {
  props: EditorProps<DgtPdOrderOperationLog, SummaryLogRow>
}) => {
  const { onClose, onRowChange, row } = props

  return <Modal show={true} onHide={onClose}
    okTheme='danger'
    okText='ยืนยัน'
    okAction={() => {
      let updatedRow = { ...row }
      delete updatedRow.confirmationId
      delete updatedRow.confirmedBy
      delete updatedRow.confirmedDate
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title='คำเตือนเนื่องจากมีการยกเลิก Confirm รายบรรทัด'
    maxWidth='max-w-lg'
    >
    <div className='flex items-center gap-3'>
      <AiOutlineClose size={50} className='text-red-500 basis-1/6 ' />
      <div className="space-y-3 ">
        <h5>คุณกำลังจะยกเลิกรายการที่ Confirm ไปแล้ว ยืนยันยกเลิกหรือไม่ ?</h5>
        <h6>คำเตือน : กรุณายกเลิกใน SAP ก่อน</h6>
      </div>
    </div>
  </Modal>
})

export default CancelConfirmEditor